
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M8 1a7 7 0 1 0 7 7 7 7 0 0 0-7-7m.75 7a.75.75 0 0 1-.75.75H5a.75.75 0 0 1 0-1.5h2.25V4a.75.75 0 0 1 1.5 0Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  